import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { NeoGridCardsView } from '../components/ui/NeoGridCardsView';
import NeoPageLayout from '../components/ui/NeoPageLayout';
import { ATS_TEAM } from '../data/blog';

const TeamView: React.FC = () => {
    const navigate = useNavigate();

    useEffect(() => {
        const navbar = document.getElementById("navbar");
        navbar?.classList.add("white-bg");
    }, []);

    return (
        <NeoPageLayout
            pageTitle="Team - ATS Global"
            pageDescription="Complete and Tailored AI Solutions"
            isLoading={false}
            logoUrl={{
                white: "/ATS_Global_Branding_SansNeo_White.png",
                black: "ATS_Global_Branding_SansNeo_Black.png"
            }}
            logoStyle={{
                height: "65px",
            }}
            logoAction={"/"}
            links={[
                {
                    title: "project x",
                    action: "/project-x",
                },
                {
                    title: "about",
                    action: "/about",
                },
                // {
                //     title: "blog",
                //     action: "/blog",
                // },
                {
                    title: "team",
                    action: "/team",
                    active: true
                },
                {
                    title: "contact us",
                    action: "/contact-us",
                },
            ]}
            mobileFooterLinks={[
                {
                    title: "NeoAI",
                    action: "https://neoworlder.ai",
                },
                {
                    title: "NeoWorlder",
                    action: "https://neoworlder.com",
                },
                {
                    title: "Lootverse",
                    action: "https://lootverse.com",
                },
            ]}
        >

            <NeoGridCardsView
                id="team"
                onNavigateBack={() => navigate("/about")}
                onNavigate={() => navigate("/contact-us")}
                gridCols={4}
                gridSpacing={"20px"}
                // pageStyle={{ paddingTop: "100px" }}
                title="Team"
                subtitle="Decades of experience in the AI sector."
                cardItems={ATS_TEAM.map(team => ({
                    content: <img className="h-full w-full object-cover" src={team.image} />,
                    backContent: (
                        <div className="py-[15px] px-[28px]">
                            <p className="text-[16px] font-semibold mb-[3px]">{team.name}</p>
                            <p className="text-[14px] mb-[10px]">{team.title}</p>
                            <p className="text-[12px]">{team.email}</p>
                        </div>
                    ),
                }))}
            />
        </NeoPageLayout>
    );
};

export default TeamView;
